import { createContext, useContext } from 'react';
import { OptionsCalculatorComputedContextType } from './OptionsCalculatorContextProvider';

export const OptionsCalculatorComputedContext =
  createContext<OptionsCalculatorComputedContextType | null>(null);

export const useOptionsCalculatorComputed =
  (): OptionsCalculatorComputedContextType => {
    const context = useContext(OptionsCalculatorComputedContext);
    if (context == null) {
      throw new Error(
        'useOptionsCalculatorComputed must be used within OptionsCalculatorProvider',
      );
    }
    return context;
  };
